import { pipe } from "fp-ts/function";
import { option } from "fp-ts";

type Format = Pick<Intl.NumberFormat, "format">;

const fractionDigitsConfig = {
    minimumFractionDigits: 0, // No decimals if the value is an integer
    maximumFractionDigits: 2, // Decimals up to two places if needed
};

export const priceFormat = (locale: string, currency?: string) => {
    return pipe(
        option.tryCatch(
            (): Format =>
                new Intl.NumberFormat(locale, {
                    style: "currency",
                    currency,
                    ...fractionDigitsConfig,
                })
        ),
        option.getOrElse((): Format => {
            const numberFormat = new Intl.NumberFormat(locale, {
                style: "decimal",
                ...fractionDigitsConfig,
            });

            const currencySuffix = currency == null ? "" : ` ${currency}`;

            return {
                format: (value: number) => {
                    return `${numberFormat.format(value)}${currencySuffix}`;
                },
            };
        })
    );
};
